<template lang="html">
  <action-bar id="floorplan-detail-actions" class="d-none d-md-flex">
    <!-- Left -->
    <template slot="left">
      <!-- Back -->
      <div class="d-none d-md-flex">
        <router-link :to="{ name: backUrl }"
        class="btn btn-link-action btn-back"
        @click="backToList()">
          <i class="far fa-angle-left mr-2"></i> Floorplan list
        </router-link>
        <!-- Download PDF -->
        <a v-if="!isTouchscreen"
        :href="assetsUrl + floorplan.assets.pdf.url"
        target="_blank"
        download
        class="btn btn-link-action d-none d-md-inline-block">
          <i class="fas fa-file-pdf"></i> Save PDF
        </a>
        <button v-else
        class="btn btn-link-action d-none d-md-inline-block"
        @click="emailFloorplan()">
          <i class="fas fa-file-pdf"></i> Email Floorplan
        </button>
      </div>

    </template>

    <!-- Right -->
    <template slot="right">
      <compare-btn :floorplanId="floorplan.id"/>
    </template>
  </action-bar>
</template>

<script>
import { mapState } from 'vuex';
import { create } from 'vue-modal-dialogs';
import Email from '@/services/email';
import KeyboardInputDialog from '@/components/Dialogs/KeyboardInputDialog';
import CompareButtonComponent from '@/components/Floorplan/CompareButton';
import ActionBar from '@/components/ActionBar';

const keyboardDialog = create(KeyboardInputDialog, 'prevText');

export default {
  name: 'floorplan-detail-actions',
  props: {
    floorplan: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapState({
      showFavourites: state => state.floorplans.showFavourites,
      assetsUrl: state => state.project.assetsUrl,
      isTouchscreen: state => state.project.isTouchscreen
    }),
    backUrl() {
      if (this.showFavourites) {
        return 'FloorplanFavourites';
      }
      return 'FloorplanList';
    }
  },
  methods: {
    async emailFloorplan() {
      const email = await keyboardDialog(this.text);
      if (email) {
        this.$toasted.show('Emailing floorplan...', {
          position: 'top-center',
          duration: 4000
        });
        const result = await Email.send(email,
          [this.floorplan]);
        this.$toasted.clear();
        if (result.status === 'success') {
          this.$toasted.show(result.msg, {
            theme: 'success',
            position: 'top-center',
            duration: 4000,
            type: 'success'
          });
        } else {
          this.$toasted.show(result.msg, {
            theme: 'error',
            position: 'top-center',
            duration: 4000,
            type: 'error'
          });
        }
      }
    }
  },
  components: {
    'compare-btn': CompareButtonComponent,
    'action-bar': ActionBar
  }
};
</script>

<style lang="scss" scoped>
.btn-back {
  margin-left: -0.5rem;
}

#floorplan-detail-actions {
  -webkit-box-shadow: 0px -1px 5px 0px rgba(0,0,0,0.15);
  -moz-box-shadow: 0px -1px 5px 0px rgba(0,0,0,0.15);
  box-shadow: 0px -1px 5px 0px rgba(0,0,0,0.15);
}
</style>



// WEBPACK FOOTER //
// src/pages/FloorplansPage/FloorplanDetail/FloorplanDetailActions.vue